/* eslint-disable consistent-return */
import eventQueue from '../queue';
import { EventAction } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var _b, _c;
        var data = _a.data, fireAnalyticsEvent = _a.fireAnalyticsEvent, state = _a.state;
        var fireEmployerOrPlatformSelectedEvent = function (eventParams, eventType) {
            fireAnalyticsEvent(EventAction.EMPLOYER_OR_PLATFORM_SELECTED, eventParams, eventType);
        };
        if (data.eventId === 'MSE-selectProvider') {
            /*
             * Our current segment system cannot handle the `platform_id` and
             * `employer_id` set up directly, so instead we pass in the overrides.
             */
            return fireEmployerOrPlatformSelectedEvent({
                platformIdOverride: (_b = state.providerEntity.selectedPlatform) === null || _b === void 0 ? void 0 : _b.id,
                employerIdOverride: (_c = state.providerEntity.selectedEmployer) === null || _c === void 0 ? void 0 : _c.id,
            });
        }
    });
}
attachEventListeners();
